import { Badge } from "reactstrap";

// TODO CLEANUP: Remove deprecated config4js.js imports (ZAI-68)
// config4js.js is deprecated in favor of service_config.js
// Use window.getBackendUrl() instead
// See: https://tadepalli.atlassian.net/browse/ZAI-68
// import { serverUrl } from "../config4js.js";

// Use service_config.js instead (loaded globally via index.html)
const serverUrl = window.getBackendUrl();

export const notify = (
  notifMessage,
  notificationAlertRef,
  color = "success",
  icon = "tim-icons icon-check-2"
) => {
  var options = {};
  options = {
    place: "br",
    message: (
      <div>
        <div>{notifMessage}</div>
      </div>
    ),
    type: color,
    icon: icon,
    autoDismiss: 4,
  };
  if (notificationAlertRef && notificationAlertRef.current) {
    notificationAlertRef.current.notificationAlert(options);
  }
};

export const getColor = (text, isFocused) => {
  if (isFocused) {
    return "default";
  }
  if (text === "physics") {
    return "success";
  } else if (text === "coding") {
    return "warning";
  } else if (text === "robotics") {
    return "danger";
  } else {
    return "info";
  }
};

export const renderChip = (
  {
    value,
    text,
    chip,
    isFocused,
    isDisabled,
    isReadOnly,
    handleClick,
    handleDelete,
    className,
  },
  key
) => {
  return (
    <Badge color={getColor(text.toLowerCase(), isFocused)}>
      {text.toLowerCase()}
    </Badge>
  );
};

export const renderNames = (city, state, country, zip) => {
  var total = "";
  if (city !== "" && city !== undefined) {
    total += city + ", ";
  }
  if (state !== "" && state !== undefined) {
    total += state + ", ";
  }
  if (country !== "" && country !== undefined) {
    total += country + ", ";
  }
  return total.replace(/\s*,\s*$/, "");
};

export const getCookie = cname => {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(";");
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) === " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
};

// function: getProjects()
// param: userID (legacy, now uses session_id from cookie/localStorage)
// return: Object, each item in obj contains a project w/ info
export function getProjects(userID, callback) {
  // Get session_id from cookie or localStorage (preferred method)
  var sessionId = getCookie("ziroatoken");
  if (!sessionId) {
    sessionId = localStorage.getItem('ziro_session_id');
  }
  
  // Verify it's a session_id (UUID format), not legacy JWT
  const isSessionId = sessionId && sessionId.includes('-') && sessionId.length === 36 && !sessionId.includes('.');
  if (!isSessionId) {
    console.error("❌ Utils.getProjects: No valid session_id found - user needs to log in");
    callback("Error: No valid session");
    return;
  }
  
  let xhr = new XMLHttpRequest();
  // Use session_id parameter (backend only accepts session_id now)
  var apiEndpoint = serverUrl + "/fetchprojects?session_id=" + sessionId;
  console.log("Utils.getProjects:", apiEndpoint);
  xhr.open("GET", apiEndpoint);

  xhr.onload = function () {
    if (xhr.status === 401) {
      console.error("❌ Utils.getProjects: 401 Unauthorized - session expired");
      callback("Error: Session expired");
      return;
    }
    try {
      const response = JSON.parse(xhr.responseText);
      if ("status" in response) {
        return;
      }
      if(xhr.status === 200){
        callback(response);
      } else {
        callback("Error" + xhr.status);
      }
    } catch (e) {
      console.error("❌ Utils.getProjects: Error parsing response", e);
      callback("Error: Invalid response");
    }
  };
  xhr.onerror = function() {
    console.error("❌ Utils.getProjects: Network error");
    callback("Error: Network error");
  };
  xhr.send();
}

//getLists: display all lists by param userID (legacy, now uses session_id)
export function getLists(userID, callback){
  // Get session_id from cookie or localStorage
  var sessionId = getCookie("ziroatoken");
  if (!sessionId) {
    sessionId = localStorage.getItem('ziro_session_id');
  }
  
  // Verify it's a session_id (UUID format)
  const isSessionId = sessionId && sessionId.includes('-') && sessionId.length === 36 && !sessionId.includes('.');
  if (!isSessionId) {
    console.error("❌ Utils.getLists: No valid session_id found - user needs to log in");
    callback("Error: No valid session");
    return;
  }
  
  let xhr = new XMLHttpRequest();
  // Use session_id parameter (backend only accepts session_id now)
  var apiEndpoint = serverUrl + "/fetchuserplaylists?session_id=" + sessionId;
  console.log("Utils.getLists:", apiEndpoint);
  xhr.open("GET", apiEndpoint);

  xhr.onload = function () {
    if (xhr.status === 401) {
      console.error("❌ Utils.getLists: 401 Unauthorized - session expired");
      callback("Error: Session expired");
      return;
    }
    try {
      const response = JSON.parse(xhr.responseText);
      if ("status" in response) {
        return;
      }
      if(xhr.status === 200){
        callback(response);
      } else {
        callback("Error" + xhr.status);
      }
    } catch (e) {
      console.error("❌ Utils.getLists: Error parsing response", e);
      callback("Error: Invalid response");
    }
  };
  xhr.onerror = function() {
    console.error("❌ Utils.getLists: Network error");
    callback("Error: Network error");
  };
  xhr.send();
}

//getUserLists: get lists of user (of person viewing page)
// param: token (legacy, now uses session_id from cookie/localStorage)
export function getUserLists(token, callback){
  // Get session_id from cookie or localStorage (preferred method)
  var sessionId = getCookie("ziroatoken");
  if (!sessionId) {
    sessionId = localStorage.getItem('ziro_session_id');
  }
  
  // Verify it's a session_id (UUID format), not legacy JWT
  const isSessionId = sessionId && sessionId.includes('-') && sessionId.length === 36 && !sessionId.includes('.');
  if (!isSessionId) {
    console.error("❌ Utils.getUserLists: No valid session_id found - user needs to log in");
    callback("Error: No valid session");
    return;
  }
  
  let xhr = new XMLHttpRequest();
  // Use session_id parameter - CRITICAL FIX: backend no longer accepts authtoken
  var apiEndpoint = serverUrl + "/fetchuserplaylists?session_id=" + sessionId;
  console.log("Utils.getUserLists:", apiEndpoint);
  xhr.open("GET", apiEndpoint);

  xhr.onload = function () {
    if (xhr.status === 401) {
      console.error("❌ Utils.getUserLists: 401 Unauthorized - session expired");
      callback("Error: Session expired");
      return;
    }
    try {
      const response = JSON.parse(xhr.responseText);
      if ("status" in response) {
        return;
      }
      if(xhr.status === 200){
        callback(response);
      } else {
        callback("Error" + xhr.status);
      }
    } catch (e) {
      console.error("❌ Utils.getUserLists: Error parsing response", e);
      callback("Error: Invalid response");
    }
  };
  xhr.onerror = function() {
    console.error("❌ Utils.getUserLists: Network error");
    callback("Error: Network error");
  };
  xhr.send();
}

export function getProfile(userID, callback){
  // Get session_id from cookie or localStorage
  var sessionId = getCookie("ziroatoken");
  if (!sessionId) {
    sessionId = localStorage.getItem('ziro_session_id');
  }
  
  // Verify it's a session_id (UUID format)
  const isSessionId = sessionId && sessionId.includes('-') && sessionId.length === 36 && !sessionId.includes('.');
  if (!isSessionId) {
    // For unauthenticated users, call callback with null instead of error string
    // This allows pages to work without authentication
    console.warn("⚠️ Utils.getProfile: No valid session_id found - continuing without profile data");
    callback(null);
    return;
  }
  
  let xhr = new XMLHttpRequest();
  // Use session_id parameter (backend only accepts session_id now)
  var apiEndpoint = serverUrl + "/fetchprofile?session_id=" + sessionId;
  console.log("Utils.getProfile:", apiEndpoint);
  xhr.open("GET", apiEndpoint);

  xhr.onload = function () {
    if (xhr.status === 401) {
      // 401 Unauthorized - user is not authenticated, continue without profile data
      console.warn("⚠️ Utils.getProfile: 401 Unauthorized - continuing without profile data");
      callback(null);
      return;
    }
    try {
      const response = JSON.parse(xhr.responseText);
      if (response[0] === undefined) {
        // No profile found - continue without profile data
        callback(null);
        return;
      }
      if(xhr.status === 200){
        callback(response[0]);
      } else {
        // Other error status - continue without profile data
        console.warn(`⚠️ Utils.getProfile: HTTP ${xhr.status} - continuing without profile data`);
        callback(null);
      }
    } catch (e) {
      // Parse error - continue without profile data
      console.warn("⚠️ Utils.getProfile: Error parsing response - continuing without profile data", e);
      callback(null);
    }
  };
  xhr.onerror = function() {
    // Network error - continue without profile data
    console.warn("⚠️ Utils.getProfile: Network error - continuing without profile data");
    callback(null);
  };
  xhr.send();
}

export function getStarred(userID, callback){
  // Get session_id from cookie or localStorage
  var sessionId = getCookie("ziroatoken");
  if (!sessionId) {
    sessionId = localStorage.getItem('ziro_session_id');
  }
  
  // Verify it's a session_id (UUID format)
  const isSessionId = sessionId && sessionId.includes('-') && sessionId.length === 36 && !sessionId.includes('.');
  if (!isSessionId) {
    console.error("❌ Utils.getStarred: No valid session_id found - user needs to log in");
    callback("Error: No valid session");
    return;
  }
  
  let xhr = new XMLHttpRequest();
  // Use session_id parameter (backend only accepts session_id now)
  var apiEndpoint = serverUrl + "/fetchstarred?session_id=" + sessionId;
  console.log("Utils.getStarred:", apiEndpoint);
  xhr.open("POST", apiEndpoint);

  xhr.onload = function () {
    if (xhr.status === 401) {
      console.error("❌ Utils.getStarred: 401 Unauthorized - session expired");
      callback("Error: Session expired");
      return;
    }
    try {
      const response = JSON.parse(xhr.responseText);
      if (response[0] === undefined) {
        return;
      }
      if(xhr.status === 200){
        callback(response);
      } else {
        callback("Error" + xhr.status);
      }
    } catch (e) {
      console.error("❌ Utils.getStarred: Error parsing response", e);
      callback("Error: Invalid response");
    }
  };
  xhr.onerror = function() {
    console.error("❌ Utils.getStarred: Network error");
    callback("Error: Network error");
  };
  xhr.send();
}

export function addPlaylist(token, fileID, lists, callback) {
  // Get session_id from cookie or localStorage (token param is legacy)
  var sessionId = getCookie("ziroatoken");
  if (!sessionId) {
    sessionId = localStorage.getItem('ziro_session_id');
  }
  
  // Verify it's a session_id (UUID format)
  const isSessionId = sessionId && sessionId.includes('-') && sessionId.length === 36 && !sessionId.includes('.');
  if (!isSessionId) {
    console.error("❌ Utils.addPlaylist: No valid session_id found - user needs to log in");
    callback([]);
    return;
  }
  
  let xhr = new XMLHttpRequest();
  // Use session_id parameter (backend only accepts session_id now)
  var apiEndpoint = serverUrl + "/getplaylistsforproject?session_id=" + sessionId;
  console.log("Utils.addPlaylist:", apiEndpoint);
  xhr.open("POST", apiEndpoint);
  xhr.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
  
  xhr.onload = function () {
    if (xhr.status === 401) {
      console.error("❌ Utils.addPlaylist: 401 Unauthorized - session expired");
      callback([]);
      return;
    }
    try {
      var list_ids = JSON.parse(xhr.responseText);
      list_ids = list_ids.map(list_id => list_id.playlist_id);
      const updatedCheckedState = lists.map((item) => {
        if (list_ids.includes(item.playlist_id)) {
          return true;
        } else {
          return false;
        }
      });
      callback(updatedCheckedState);
    } catch (e) {
      console.error("❌ Utils.addPlaylist: Error parsing response", e);
      callback([]);
    }
  };
  xhr.onerror = function() {
    console.error("❌ Utils.addPlaylist: Network error");
    callback([]);
  };
  xhr.send(
    JSON.stringify({
      project_id: fileID,
    })
  );
}

export const descStyle = {
  display: "block",
  textOverflow: "ellipsis",
  overflow: "hidden",
  whiteSpace: "nowrap",
  marginBottom: 5
}

/**
 * Get the thumbnail bucket name based on environment
 * Uses centralized environment detection from config_loader.js
 * @returns {string} Bucket name for thumbnails
 */
export function getThumbnailBucketName() {
  // Use environment-aware config from service_config if available (preferred)
  if (window.SERVICE_CONFIG && window.SERVICE_CONFIG.storage && window.SERVICE_CONFIG.storage.userThumbnails) {
    return window.SERVICE_CONFIG.storage.userThumbnails;
  }
  
  // Fallback: Use centralized environment detection (single source of truth)
  const env = window.getZiroEnvironment ? window.getZiroEnvironment() : 'prod';
  
  if (env === 'dev') {
    return 'ziro-dev-user-thumbnails';
  } else if (env === 'test') {
    return 'ziro-ai-staging-user-thumbnails';
  } else {
    // prod
    return 'user-thumbnails';
  }
}

/**
 * Get the full thumbnail URL for a project
 * @param {string} fileId - Project file ID
 * @param {number} timestampModified - Optional timestamp for cache-busting
 * @returns {string} Full thumbnail URL
 */
export function getThumbnailUrl(fileId, timestampModified = null) {
  const bucketName = getThumbnailBucketName();
  let url = `https://storage.googleapis.com/${bucketName}/${fileId}.jpg`;
  
  if (timestampModified) {
    url += `?t=${Math.floor(timestampModified)}`;
  }
  
  return url;
}

export function addDefaultSrc(ev){
  // Use direct Storage URL for default thumbnails (bucket is publicly readable)
  const bucketName = getThumbnailBucketName();
  ev.target.src = `https://storage.googleapis.com/${bucketName}/ziro-studio-default` +
    (Math.floor(Math.random() * 5) + 1) +
    ".jpg";
}